/* global localStorage */
import axios from 'axios'
const API_URL = process.env.API_URL || axios.defaults.baseURL

export default axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `${localStorage.getItem('Authorization')}`
  }
})